module.exports = __webpack_public_path__ + "img/biaoqian.4291c040.png";